import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=536d3b1f"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=536d3b1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports